$(function($){

  'use strict';

  CartJS.getCart();

  var _pc = window._pc || {};

  var _updateItem = async (line, quantity) => {
    const cartData = JSON.parse(JSON.stringify(CartJS.cart))
    // console.log(line - 1,quantity,cartData)
    if (!cartData?.items?.length) return cartData

    const lineItem = cartData.items[line - 1];
    // console.log(lineItem)
    if (lineItem?.properties && !!lineItem.properties['_bundle_group']?.length) {
      console.log('Ignore this update because it is a bundle line item!')
      return cartData
    }

    return await CartJS.updateItem(line, quantity);
  }

_pc.set = function() {

  $('[data-mh]').matchHeight();
  $('[data-mhnr]').matchHeight({byRow: false});

  $('.three-cols .three-col .col-img').matchHeight();


  if($('[data-nav]').length) {
    var navColor = $('[data-nav]').attr('data-nav');

    if(navColor == 'navcolblue') {
      $('body').addClass('header-dark').removeClass('header-trans');
    } else if(navColor == 'navcoldefault') {
      $('body').removeClass('header-trans');
    }

    if(navColor == 'navcolwhite') {
      $('body').addClass('header-trans');
    }

  }

  window.setTimeout(function () {
    $('.main-header').addClass('header-ready');
  }, 500);


};

_pc.scrolls = function() {

  // NEXT OR FIRST
  $.fn.nextOrFirst = function(selector) {
    var next = this.next(selector);
    return (next.length) ? next : this.prevAll(selector).last();
  };

  // SCROLL TO NEXT
  $('[data-scroll="next"]').on('click', function (e) {
    e.preventDefault();
    $.scrollTo($(this).closest('section').next(), {
      axis : 'y',
      offset : 0,
      duration : 600
    });
  });

  // SCROLL TO HASH
  $('[data-scroll="hash"]').on('click', function (e) {
    e.preventDefault();

    var offset = 0;

    if ($(this).attr("data-offset")) {
      offset = $(this).data('offset');
    }

    if ($(this).attr("data-offset-mobile") && window.innerWidth < 768) {
      offset = $(this).data('offset-mobile');
    }

    $.scrollTo(this.hash, {
      axis : 'y',
      offset : offset,
      duration : 600
    });
  });

  // SCROLL TO TOP
  $('[data-scroll="top"]').click(function() {
    $("html, body").animate({ scrollTop: 0 });
    return false;
  });


  // $(window).on("load scroll",function(e){
  //   var $this = $(this);
  //   var main = $('main');
  //   var totalHeight = $(document).height();
  //   var mainHeight = main.outerHeight();
  //   var aspotHeight = $('#aspot').outerHeight();

  //   if ($this.scrollTop() > aspotHeight) {
  //     $("body").addClass('in-main');
  //   } else {
  //     $("body").removeClass('in-main');
  //   }
  //   if ($this.scrollTop() > totalHeight/2) {
  //     $("body").addClass('in-mid');
  //   } else {
  //     $("body").removeClass('in-mid');
  //   }
  //   if ($this.scrollTop() > 0) {
  //     $("body").addClass('has-scrolled');
  //   } else {
  //     $("body").removeClass('has-scrolled');
  //   }
  // });

  $(window).on("load scroll",function(e){
    var $this = $(this);
    var headerHt = $('#site-header').outerHeight();
    var aspotHeight = $('#aspot').outerHeight();

    if ($this.scrollTop() > headerHt) {
      $("body").addClass('passed-header');
    } else {
      $("body").removeClass('passed-header');
    }
    if ($this.scrollTop() > headerHt*2) {
      $("body").addClass('ready-header');
    } else {
      $("body").removeClass('ready-header');
    }
    if ($this.scrollTop() > aspotHeight) {
      $("body").addClass('passed-aspot');
    } else {
      $("body").removeClass('passed-aspot');
    }
    if ($this.scrollTop() > 0) {
      $("body").addClass('has-scrolled');
    } else {
      $("body").removeClass('has-scrolled');
    }
  });

};

_pc.toggleNav = function(){

  $('[data-toggle="mobile-navigation"]').on('click', function (e) {
    e.preventDefault();
    if ( $(this).hasClass('toggled') ) {
      closeNav();
    } else {
      openNav();
    }
  });

  function openNav() {
    $('#mobile-navigation').addClass('is-visible');
    $('[data-toggle="mobile-navigation"]').addClass('toggled');
    $('body').addClass('show-nav');
    $('body').addClass('js-no-scroll');
  }

  function closeNav() {
    $('#mobile-navigation').removeClass('is-visible');
    $('[data-toggle="mobile-navigation"]').removeClass('toggled');
    $('body').removeClass('show-nav');
    $('body').removeClass('js-no-scroll');
  }



  $('#mobile-navigation .has-drop .droptoggle').on('click', function (e) {
    e.preventDefault();

      if($(this).parents('li').hasClass('drp-open')) {
        $(this).parents('a').next('.drpdwn').slideUp(250,'swing');
        $(this).parents('li').removeClass('drp-open');
      } else {
        $(this).parents('li').siblings('.has-drop').find('.drpdwn').slideUp(250,'swing');
        $(this).parents('li').siblings('.has-drop').removeClass('drp-open');
        $(this).parents('a').next('.drpdwn').slideDown(250,'swing');
        $(this).parents('li').addClass('drp-open');
      }

  });

};

_pc.slick = function(){

  $('[data-slick]').slick({
    lazyLoad: 'progressive',
    fade: true,
    speed: 400,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          // arrows: false,
          fade: false,
          speed: 300,
        }
      }
    ]
  });

  $('.section-products-slider:not(.section-products-slider--redesign) .products-slider:not(.rel-products-slider)').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.section-products-slider .products-slider:not(.rel-products-slider)').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider .products-slider:not(.rel-products-slider)').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });



  $('.section-products-slider .rel-products-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.section-products-slider .rel-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider .rel-products-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider--redesign .products-slider--redesign').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"></button>',
    nextArrow: '<button class="slide-next"></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.section-products-slider--redesign .products-slider--redesign').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider--redesign .products-slider--redesign').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.slide-slider').not('.slick-initialized').each(function () {
    const numberOfSlides = $(this).find('.slide-slider-slide').length;
    $(this).slick({
      fade: false,
      speed: 400,
      cssEase: 'ease-out',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: numberOfSlides > 1,
      // appendArrows: '.slider-arrows',
      prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
      nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
      centerMode: true,
      centerPadding: '0',
      autoplay: false,
      pauseOnHover: true,
      touchThreshold: 20
    });
  });


  $(".slide-slider .slick-arrow").click(function(e){
    e.preventDefault();
  });

  $('.section-insta-slider .insta-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'linear',
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.instslider-arrows',
    prevArrow: '<button class="slide-prev"></button>',
    nextArrow: '<button class="slide-next"></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });


  $('.section-reviews-slider .reviews-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.revslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('#revived .revived-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.revived-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('#revived .revived-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('#revived .revived-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });


  //   $('.page-product product-images-slider').not('.slick-initialized').slick({
  //     fade: false,
  //     speed: 400,
  //     cssEase: 'ease-out',
  //     dots: false,
  //     arrows: false,
  //     slidesToShow: 2,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     // appendArrows: '.slider-arrows',
  //     prevArrow: '<button class="slide-prev"><i class="_pcicon-longarrow-left"></i></button>',
  //     nextArrow: '<button class="slide-next"><i class="_pcicon-longarrow-right"></i></button>',
  //     centerMode: true,
  //     centerPadding: '0',
  //     autoplay: false,
  //     pauseOnHover: true,
  //     touchThreshold: 20
  //   });


  //   $('.page-product product-images-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  //     // bLazy.revalidate();
  //   });

  //   $('.page-product product-images-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  //     // bLazy.revalidate();
  //   });



  $('.hero-slider').not('.slick-initialized').each(function () {
    const $slider = $(this);
    const autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
    const autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10) || 3000;

    $slider.slick({
      fade: false,
      speed: 400,
      cssEase: 'ease-out',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      appendArrows: '.heroslider-arrows',
      prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
      nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
      // centerMode: false,
      // centerPadding: '0',
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      pauseOnHover: true,
      touchThreshold: 20
    });
  });

  $('.hero-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.hero-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });




  $('.hiw-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.hiwslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20
  });




  $('.cart-mini .rec-products-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          appendArrows: '.prodslider-arrows'
        }
      }
    ]
  });


  $('.cart-mini .rec-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.cart-mini .rec-products-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

};

_pc.accordion = function(){

  if($('.accordion:not(.has-buddies)').length) {

    $('.accordion-wrap').first().addClass('info-active');
    $('.accordion-wrap').first().find('.info-answer').slideDown(250,'swing');

    $('.accordion-wrap').click(function(e) {
      e.preventDefault();

      if($(this).hasClass('info-active')) {
        $(this).find('.info-answer').slideUp(250,'swing');
        $(this).removeClass('info-active');
      } else {
        $(this).siblings('.accordion-wrap').find('.info-answer').slideUp(250,'swing');
        $(this).siblings('.accordion-wrap').removeClass('info-active');
        $(this).find('.info-answer').slideDown(250,'swing');
        $(this).addClass('info-active');
      }


    });

    $('.accordion-wrap a').click(function(e) {
      e.stopPropagation();
    });

  }


  if($('.accordion.has-buddies').length) {

    $('.accordion-wrap').first().addClass('info-active');
    $('.accordion-wrap').first().find('.info-answer').slideDown(250,'swing');

    window.setTimeout(function () {

      var maxHeight = $('.acc-buddies .acc-buddy.active').outerHeight();

      $('.acc-buddies').css('height', maxHeight+'px');

    }, 1500);


    $(window).on("resize",function(e){

      var maxHeight = $('.acc-buddies .acc-buddy.active').outerHeight();

      $('.acc-buddies').css('height', maxHeight+'px');

    });


    $('.accordion-wrap').click(function(e) {
      e.preventDefault();

      var buddy = $(this).attr('data-buddy');

      if($(this).hasClass('info-active')) {
        // $(this).find('.info-answer').slideUp(250,'swing');
        // $(this).removeClass('info-active');

        // $('.acc-buddy#'+buddy).removeClass('active');

        // $('.acc-buddies').css('height', 'auto');

      } else {
        $(this).siblings('.accordion-wrap').find('.info-answer').slideUp(250,'swing');
        $(this).siblings('.accordion-wrap').removeClass('info-active');
        $(this).find('.info-answer').slideDown(250,'swing');
        $(this).addClass('info-active');

        var maxHeight = $('.acc-buddy#'+buddy).outerHeight();

        $('.acc-buddies').css('height', maxHeight+'px');

        $('.acc-buddy#'+buddy).siblings('.acc-buddy').removeClass('active');
        $('.acc-buddy#'+buddy).addClass('active');
      }



    });

    $('.accordion-wrap a').click(function(e) {
      e.stopPropagation();
    });

  }


  $('.accordion-wrap .inner p > a[title="chevlink"]').addClass('chevlink').append('<i></i>');

};

_pc.scrollMagic = function() {


  if($('#how-it-works').length) {

    // ORIGNAL
    // window.setTimeout(function () {

    //   var controller = new ScrollMagic.Controller();


    //   var sectHt = $('#how-it-works').outerHeight();
    //   var introHt = $('.hiw-intro-wrap').outerHeight();
    //   var contHt = $('.hiw-intro-cont').outerHeight();
    //   var newSectHt = sectHt - contHt;
    //   var newSectHt = newSectHt - introHt;

    //   var scene = new ScrollMagic.Scene({
    //     triggerElement: '#how-it-works',
    //     offset: introHt,
    //     triggerHook: 0,
    //     duration: newSectHt,
    //     reverse: true
    //   })
    //   .setClassToggle('.hiw-desc-wrap', 'is-inside')
    //   .setPin('.hiw-desc-wrap')
    //   .addTo(controller);


    //   $('.hiw-img').each(function(index) {
    //     var introHt = $('.hiw-intro-wrap').outerHeight();
    //     var introHt = introHt + 40;
    //     var imgHt = $(this).outerHeight();
    //     var imgRow = $(this).attr('data-hiwimg');

    //     var imgScene = new ScrollMagic.Scene({
    //       triggerElement: this,
    //       offset: -40,
    //       triggerHook: 0,
    //       duration: imgHt,
    //       reverse: true
    //     })
    //     .setClassToggle('.hiwdesc-'+imgRow, 'active')
    //     .addTo(controller);

    //   });

    // }, 750);

    window.setTimeout(function () {

      var controller = new ScrollMagic.Controller();

	  var brwsrHt = $(window).height();
      var sectHt = $('#how-it-works').outerHeight();
      var introHt = $('.hiw-intro-wrap').outerHeight();
      var contHt = $('.hiw-intro-cont').outerHeight();
      var newSectHt = sectHt - contHt;

      var offsetHt = ((brwsrHt / 2) - contHt) * -1;
      var newSectHt = (newSectHt - introHt) - 80;

      var scene = new ScrollMagic.Scene({
        triggerElement: '#how-it-works',
        offset: offsetHt,
        triggerHook: 0,
        duration: newSectHt,
        reverse: true
      })
      .setClassToggle('.hiw-desc-wrap', 'is-inside')
      .setPin('.hiw-intro-cont')
      .addTo(controller);

      // scene.setClassToggle('#how-it-works', 'sect-active')


      $('.hiw-img').each(function(index) {
        var introHt = $('.hiw-intro-wrap').outerHeight();
        var introHt = introHt + 40;
        var imgHt = $(this).outerHeight();
        var imgRow = $(this).attr('data-hiwimg');

        var imgScene = new ScrollMagic.Scene({
          triggerElement: this,
          offset: offsetHt,
          triggerHook: 0,
          duration: imgHt,
          reverse: true
        })
        .setClassToggle('.hiwdesc-'+imgRow, 'active')
        // .setClassToggle('[data-hiwimg="'+imgRow+'"]', 'active')
        .addTo(controller);

        // imgScene.setClassToggle('[data-hiwimg="'+imgRow+'"]', 'active')

      });

    }, 750);


    //     function sizeAll() {
    //       var w = window.innerWidth;

    //       if ( w < 768) {
    //         scene1.enabled(false);
    //       } else {
    //         scene1.enabled(true);
    //       }

    //     }

    //     $(window).resize(sizeAll);
    //     sizeAll();

  }


  if($('[data-page="product"]').length) {

    var imgscontroll;
    var winwidth = $(window).width();

    // window.setTimeout(function () {

    //   function initScrollMagic(){

    //     imgscontroll = new ScrollMagic.Controller();

    //     var sectHt = $('.product-details-wrapper').outerHeight();
    //     var contHt = $('.product-images').outerHeight();
    //     var newSectHt = sectHt - contHt;

    //     var scene = new ScrollMagic.Scene({
    //       triggerElement: '.product-area',
    //       offset: -30,
    //       triggerHook: 0,
    //       duration: newSectHt,
    //       reverse: true
    //     })
    //     .setClassToggle('.product-area', 'is-inside')
    //     .setPin('.product-images:not(.product-images--normal)')
    //     .addTo(imgscontroll);

    //   }

    //   if( winwidth > 767) {
    //     initScrollMagic()
    //   }

    //   $(window).resize(function(){
    //     winwidth = $(window).width()

    //     if( winwidth < 768 ) {
    //       if (imgscontroll) {
    //         imgscontroll = imgscontroll.destroy(true);
    //       }
    //     } else if ( winwidth > 767 ) {
    //       if ( !imgscontroll ) {
    //         initScrollMagic()
    //       }
    //     }

    //   });

    // }, 2000);

    window.setTimeout(function () {

      function initScrollMagic(){

        imgscontroll = new ScrollMagic.Controller();

        var sectHt = $('.product-details-wrapper--v3').outerHeight();
        var contHt = $('.product-area--v3').outerHeight();
        var newSectHt = contHt - sectHt;

        var scene = new ScrollMagic.Scene({
          triggerElement: '.product-area--v3',
          offset: -30,
          triggerHook: 0,
          duration: newSectHt,
          reverse: true
        })
        .setPin('.product-details-wrapper--v3')
        .addTo(imgscontroll);

      }

      if( winwidth > 767) {
        initScrollMagic()
      }

      $(window).resize(function(){
        winwidth = $(window).width()

        if( winwidth < 768 ) {
          if (imgscontroll) {
            imgscontrol2 = imgscontroll.destroy(true);
          }
        } else if ( winwidth > 767 ) {
          if ( !imgscontroll ) {
            initScrollMagic()
          }
        }

      });

    }, 2000);

  }


};

_pc.dropLists = function(){

  drops();

  function drops() {

    $('.drop-wrap').each(function(index) {

      var drWrap = $(this);
      var toDrop = $(this).find('.drop-list');
      var drButton = $(this).find('.drop-button');
      var wrapper = $(this).find('ul');
      var initActiveAnchor = toDrop.find('li.active a');
      var initActiveCollection = initActiveAnchor.attr('data-collection');
      $('.collection-content').hide();
      $('.collection-content#comp_'+initActiveCollection).show();

      // DROP LINK CLICK
      $(drButton).click(function(e) {
        e.preventDefault();

        if ( $(drWrap).hasClass('is-dropped') ) {
          $(drWrap).removeClass('is-dropped');
          $(toDrop).removeClass('is-visible');
          $(toDrop).slideUp(250);
        } else {
          $('.drop-wrap.is-dropped .drop-list').slideUp(250);
          $('.drop-wrap.is-dropped .drop-list').removeClass('is-visible');
          $('.drop-wrap.is-dropped').removeClass('is-dropped');

          $(drWrap).addClass('is-dropped');

          $(toDrop).slideDown(250, function(e) {
            $(toDrop).addClass('is-visible');
          });
        }

      });

      // LIST LINK CLICK
      $(wrapper).find('a').click(function(e) {
        e.preventDefault();

        var toOpen = $(this).attr('data-collection');

        var linkText = $(this).find('span').text();
        var linkLi = $(this).parents('li');

        if (linkText.indexOf("Any") >= 0) {
          linkText = linkText.replace('Any ', '');
        }

        if (linkText.indexOf("All") >= 0) {
          linkText = linkText.replace('All ', '');
        }

        $(drButton).find('span').text(linkText);

        $(drWrap).removeClass('is-dropped');
        $(toDrop).removeClass('is-visible');
        $(toDrop).slideUp(250, function(e) {
          $(wrapper).find('li.active').removeClass('active');
          $(linkLi).addClass('active');
        });

        $('.collection-content').hide();
        $('.collection-content#comp_'+toOpen).show();

        window.setTimeout(function () {
          $('.slide-slider').slick('reinit');
        }, 200);
      });

    });

  }

  $(document).click(function(event){
    if ( !$(event.target).closest('.drop-wrap').length ) {
      $('.is-dropped').removeClass('is-dropped');
      $('.drop-list').removeClass('is-visible');
      $('.drop-list').slideUp(250);
    }
  });


  // FILMS PAGE - CATEGORY FILTER
  // $('#films .drop-category ul').find('a').click(function(e) {
  //   e.preventDefault();

  //   var theHash = $(this).attr('href').substr(1);

  //   $('.films-list').attr('data-cat', theHash);

  //   $('.col-film.'+theHash).removeClass('cat-hide');
  //   $('.col-film').not('.'+theHash).addClass('cat-hide');

  // });

  // // FILMS PAGE - THEATRE
  // $('#films .drop-theatre ul').find('a').click(function(e) {
  //   e.preventDefault();

  //   var theHash = $(this).attr('href').substr(1);

  //   $('.films-list').attr('data-theatre', theHash);

  //   $('.col-film.'+theHash).removeClass('theatre-hide');
  //   $('.col-film').not('.'+theHash).addClass('theatre-hide');

  // });

};

_pc.formStuff = function() {

  $('.field-wrap input.error').parents('.field-wrap').addClass('has-error');

  $('.select-field').each(function(index) {
    $(this).append('<i></i>');
  });

  $('.select-field select').on('focus', function() {
    $(this).parents('.select-field').addClass('is-focused');
  }).on('blur', function() {
    $(this).parents('.select-field').removeClass('is-focused');
  }).on('change', function() {
    $(this).parents('.select-field').removeClass('is-focused');
  });


  $('.select-field select').on('mousedown', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  }).on('mouseup', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  }).on('click', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  });


  if($('#contact_form').length) {
    $("#contact-phone").usPhoneFormat();
  }

  if($('.buyback-form').length) {

    $('.buyback-form #contact-product').change(function(){

      var theVal = $(this).val();


      console.log(theVal);


      if(theVal == "essential-sectional" || theVal == "essential-sofa" || theVal == "essential-loveseat") {
        $('.fabric-details').show();
        $('.leg-details').show();
      }

      if(theVal == "essential-ottoman") {
        $('.cushion-details').show();
      } else {
        $('.cushion-details').hide();
      }

    });

  }

};

_pc.misc = function() {

  window.setTimeout(function () {


    if($('.spr-badge').length) {

        $('.spr-badge').hide();

        var revRat = $('.spr-badge').attr('data-rating');
        var revAmt = $('.spr-badge-caption').text();
        var revAmt = revAmt.substr(0,revAmt.indexOf(' '));

      	var revRat = Math.round(revRat * 10).toFixed(1) / 10;

        var svgStar = '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24" x="0"></rect><polygon fill="#CCB560" points="14.43,10 12,2 9.57,10 2,10 8.18,14.41 5.83,22 12,17.31 18.18,22 15.83,14.41 22,10"></polygon></g></svg>';

        if( revAmt >= 1) {
          $('.prod-review-info').show();
        }


        if(revRat >= 4.5) {
          $('.prod-review-info .rev-stars').addClass('show-5');
        } else if(revRat >= 3.5 && revRat < 4.5) {
          $('.prod-review-info .rev-stars').addClass('show-4');
        } else if(revRat >= 2.5 && revRat < 3.5) {
          $('.prod-review-info .rev-stars').addClass('show-3');
        } else if(revRat >= 1.5 && revRat < 2.5) {
          $('.prod-review-info .rev-stars').addClass('show-2');
        } else if(revRat >= 0.5 && revRat < 1.5) {
          $('.prod-review-info .rev-stars').addClass('show-1');
        } else {
          $('.prod-review-info .rev-stars').addClass('show-0');
        }

        $('.prod-review-info .rev-rating').text(revRat);

        if(revAmt > 1) {
          $('.prod-review-info .rev-amount a').prepend(revAmt+' reviews');
        } else {
          $('.prod-review-info .rev-amount a').prepend(revAmt+' review');
        }

    }


  }, 2000);



  function calcHeaderHt() {
    $('.spr-review').each(function(index) {
      var titleHt = $(this).find('.spr-review-header-title').outerHeight();
      var titleHt = titleHt + 30;
      $(this).find('.spr-starratings').css('top', titleHt+'px');
    });
  }


  window.setTimeout(function () {

  	calcHeaderHt();

  }, 2000);

  $(window).on("resize",function(e){
    calcHeaderHt();
  });


  $('.prod-reviews .reviews-cta a').on('click', function (e) {

    var prodId = $('.prod-reviews .reviews-cta a').attr('data-product-id');
    var revPg = parseInt($('.prod-reviews .reviews-cta a').attr('data-page'));

    revPg = revPg + 1;

    $('.prod-reviews .reviews-cta a').remove();

    $('.prod-reviews .reviews-cta').prepend('<a href="#shopify-product-reviews" onclick="SPR.pageReviews(this)" data-product-id="'+prodId+'" data-page="'+revPg+'" class="btn">Read more reviews</a>');



  });


  $('.sabai-atc').on('click', function (e) {
    $('.cart-mini').addClass('cart-mini-open');
    $('body').addClass('minicart-open');

  });


  $('.reviews-header .newreviewtoggle').on('click', function (e) {
    e.preventDefault();

    $(this).parents('.reviews-header').next('#shopify-product-reviews').find('.spr-form').slideToggle();

  });

  if($('body.template-blog').length) {

    $('.blog-articles > .article').each(function(index) {
      $(this).find('a.article-rte-continuereading').append('<i></i>');

  	});

  }


  $('a[href="#refer-a-friend"]').on('click', function (e) {
    e.preventDefault();

    var loc = location.href;


    location.href = loc.replace(window.location.search,'') + "?tkbl_expand=true&tkbl_campaign_id=1246072";

  });



  if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
    $('body').addClass('has-topbar');
  }

  $(window).on("load",function(e){

    if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
      var topbarHt = $('.pxs-announcement-bar').outerHeight();

      $('body').addClass('topbar-'+topbarHt);

      $('.cart-mini-sidebar').css('top', topbarHt+'px');
      // $('#mobile-navigation').css('padding-top', (topbarHt+80)+'px');


    }

  });

  $(window).on("resize",function(e){

    if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
      var topbarHt = $('.pxs-announcement-bar').outerHeight();

      $('body').removeClass('topbar-47');
      $('body').removeClass('topbar-62');
      $('body').removeClass('topbar-77');

      $('body').addClass('topbar-'+topbarHt);

      $('.cart-mini-sidebar').css('top', topbarHt+'px');
      // $('#mobile-navigation').css('padding-top', (topbarHt+80)+'px');


    }

  });




//   window.setTimeout(function () {

//     if($('.klaviyo-form').length) {

//       var topbarHt = $('.pxs-announcement-bar').outerHeight();
//       var topbarHtHalf = topbarHt / 2;
//       $('.klaviyo-form').css('top', 'calc(50% + '+topbarHtHalf+'px)').css('height', 'calc(100vh - '+topbarHt+'px)');

//       $(window).on("resize",function(e){
//         var topbarHt = $('.pxs-announcement-bar').outerHeight();
//         var topbarHtHalf = topbarHt / 2;
//         $('.klaviyo-form').css('top', 'calc(50% + '+topbarHtHalf+'px)').css('height', 'calc(100vh - '+topbarHt+'px)');
//       });

//     }

//   }, 10000);






  if($('[data-page="sustainability"]').length) {
    $(window).on("load resize",function(e){

      $('.illustration-spots .illus-spot').each(function(index) {
        var captHt = $(this).find('figcaption').outerHeight();
        var captHt = captHt + 20;
        $(this).css('padding-bottom', captHt+'px');
      });

    });
  }





  jQuery(document).ready(checkContainer);

  function checkContainer () {
    if($('[class*=" kl-private-reset-css-"]').is(':visible')){
      $('[class*=" kl-private-reset-css-"]').first().addClass('klaviyo-form');
    } else {
      setTimeout(checkContainer, 50);
    }
  }

};


_pc.tracking = function() {

  $('.pxs-newsletter-form-button').click(function(e) {
    window.pintrk?.('track', 'signup');
  });

  $(document).on('submit','form.minicartform',function(){
    var ids = [];
    $('.cart-mini-item').each(function(){
      var theids = $(this).attr('data-cart-mini-item');
      ids.push(theids);
    });

	var thePrice = $('.cart-mini-subtotal-value').text().replace('$', '');
    var theQuant =  $('.cart-mini-item').length;

    window.pintrk?.('track', 'checkout', {
      value: thePrice,
      order_quantity: theQuant,
      currency: 'USD',
      product_ids: ids
    },
    function(didInit, error) {
      if (!didInit) {
        console.log(error);
      }
    });

  });

  $('.product-submit').click(function(e) {
    var thePrice = $('.product-details-wrapper').find('.price > .money').text().replace('$', '');

    window.pintrk?.('track', 'AddToCart', {
       value: thePrice,
       order_quantity: 1,
       currency: 'USD'
     },
     function(didInit, error) {
       if (!didInit) {
        console.log(error);
       } else {
        // console.log('success'+ thePrice);
       }
     });

  });



  if($('.page-product .seating-header').length) {
    if(window.location.href.indexOf("altpage") > -1) {
      $('.seating-header .chevlink').hide();
    }
  }













};

_pc.cartPage = function() {

  if($('body.template-cart').length) {

    $('.cart-item-quantity .btn-quantity--less').on('click',function (e) {
      e.preventDefault();

      var lineNo = $(this).attr('data-line');
      var currQuant = $(this).parents('.cart-quant').find('input.cart-item-quantity').val();
      var newQuant = parseInt(currQuant) - parseInt(1);

      console.log('Current Quantity: '+currQuant);
      console.log('New Quantity: '+newQuant);

      // var thisPrice = $(this).parents('[data-cart-item]').find('.cart-mini-item-price').attr('actual-value').replace('$','').replace('.00','').replace(',','');
      // var linePrice = $(this).parents('[data-cart-item]').find('.pn-total-line-item').text().replace('$','').replace('.00','').replace(',','');
      // var cartPrice = $('.cart-mini-subtotal-value').text().replace('$','').replace('.00','').replace(',','');

      // var newLinePrice = parseInt(linePrice) - parseInt(thisPrice);
      // var newCartPrice = parseInt(cartPrice) - parseInt(thisPrice);

      // var newCartPrice = newCartPrice.toString();
      // var newCartPrice = newCartPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");



      if(newQuant == '0') {

        if($('.cart-mini-item[data-cart-mini-item]').length == 1) {
          // $('.cart-flyout-inner').html('<div class="text-center cart-empty"><h3>Your cart</h3><p class="cart--empty-message">Your cart is currently empty.</p><p class="cart--cookie-message">Enable cookies to use the shopping cart</p><p class="cart--continue-browsing">Continue browsing <a href="/pages/shop">here</a>.</p></div>');
          _updateItem(lineNo, newQuant);
        } else {
          _updateItem(lineNo, newQuant);
          $(this).parents('.cart-mini-item').remove();
          $('.cart-mini').find('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');

          $('.cart-mini-item').each(function(i) {
            var newNum = ++i;
            // $(this).attr('data-prodline', newNum);
            $(this).find('[data-line]').attr('data-line', newNum);
          });

        }

        console.log('is-zero');

      } else {

        _updateItem(lineNo, newQuant);
        $(this).parents('.cart-quant').find('input.cart-item-quantity').val(newQuant);
        // $(this).parents('[data-cart-item]').find('.pn-total-line-item').text('$'+newLinePrice+'.00');
        // $(this).parents('form').find('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');

      }



      // console.log('newQuant: ' +newQuant);
      // console.log('newLinePrice: ' +newLinePrice);
      // console.log('newCartPrice: ' +newCartPrice);


      window.setTimeout(function () {
        location.reload();
      }, 500);

    });

    $('.cart-item-quantity .btn-quantity--more').on('click',function (e) {
      e.preventDefault();

      var lineNo = $(this).attr('data-line');
      var currQuant = $(this).parents('.cart-quant').find('input.cart-item-quantity').val();
      var newQuant = parseInt(currQuant) + parseInt(1);

      console.log('Current Quantity: '+currQuant);
      console.log('New Quantity: '+newQuant);

      // var thisPrice = $(this).parents('.cart-mini-item').find('.cart-mini-item-price').attr('actual-value').replace('$','').replace('.00','').replace(',','');
      // var linePrice = $(this).parents('.cart-mini-item').find('.pn-total-line-item').text().replace('$','').replace('.00','').replace(',','');
      // var cartPrice = $('.cart-mini-subtotal-value').text().replace('$','').replace('.00','').replace(',','');

      // var newLinePrice = parseInt(linePrice) + parseInt(thisPrice);
      // var newCartPrice = parseInt(cartPrice) + parseInt(thisPrice);

      // var newCartPrice = newCartPrice.toString();
      // var newCartPrice = newCartPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");



      _updateItem(lineNo, newQuant);
      $(this).parents('.cart-quant').find('input.cart-item-quantity').val(newQuant);
      // $(this).parents('[data-cart-item]').find('.pn-total-line-item').text('$'+newLinePrice+'.00');
      // $(this).parents('form').find('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');


      // console.log('newQuant: ' +newQuant);
      // console.log('thisPrice: ' +thisPrice);
      // console.log('newLinePrice: ' +newLinePrice);
      // console.log('newCartPrice: ' +newCartPrice);

      window.setTimeout(function () {
        location.reload();
      }, 500);


    });

  }

};

var isCartClick = false;

_pc.cartClick = function() {


  $('.minicart-close').on('click', function (e) {
    e.preventDefault();

    $('.cart-mini').removeClass('cart-mini-open');
    $('body').removeClass('minicart-open');
    $('html').removeClass('scroll-locked');

  });


  $('.mini-cart-wrap').on('click',function (e) {
	var cartCount =  $('.main-header--tools-group .mini-cart-wrap .item-count').text();
    if(cartCount == '0') {
      $('.cart-mini-rec').addClass('hide-rec');
    }
    if(cartCount != '0') {
      $('.cart-mini-rec').removeClass('hide-rec');
    }
  });



  /*
  $('.mini-cart-wrap').on('click',function (e) {
    e.preventDefault();

    // $('#cart-flyout .cart-flyout-inner').load('/cart main > .cart-content > .container > *');

    $('Z .cart-mini-sidebar').load('/cart main > .cart-content > .container > *',function(){

      $('#cart-flyout .cart-flyout-inner .table-wrap > table').removeClass('responsive-table');

      if(!$('.viewcart-link').length) {
        $('#cart-flyout .cart__footer button[name="update"]').after('<a href="/cart" class="viewcart-link">View cart</a>');
      }

      $('body').addClass('flyout-visible');

      $('.mini-cart').addClass('is-visible');


      // SF -  Modify ajax cart
      const previewLink = $(this).find('.jslghtbx-thmb');

      if (previewLink.length) {
        var lightbox = new Lightbox();
        var lightBoxOptions = {
          // options
          boxId: false,
          dimensions: true,
          captions: true,
          prevImg: false,
          nextImg: false,
          hideCloseBtn: true,
          closeOnClick: true,
          loadingAnimation: 0,
          animElCount: 4,
          preload: true,
          carousel: true,
          animation: 400,
          nextOnClick: true,
          responsive: true,
          maxImgSize: 0.8,
          keyControl: true,
          onclose: function(){
            $(".jslghtbx-close").hide();
          },
          onload: function(event){
            $('.jslghtbx-contentwrapper').prepend('<span id="jslghtbx-close" class="jslghtbx-close"></span>');
          }
        };

        lightbox.load(lightBoxOptions);
      }
      // END SF -  Modify ajax cart

      cartFlyoutUpdater();
    });

    // window.setTimeout(function () {

    //   // $('#cart-flyout .cart-flyout-inner').find('[data-label="Quantity"] input').attr("disabled", true);
    //   $('#cart-flyout .cart-flyout-inner .table-wrap > table').removeClass('responsive-table');
    //   if(!$('.viewcart-link').length) {
    //     $('#cart-flyout .cart__footer button[name="update"]').after('<a href="/cart" class="viewcart-link">View cart</a>');
    //   }
    //   $('body').addClass('flyout-visible');
    //   $('#cart-flyout').addClass('is-visible');
    // }, 250);

    // window.setTimeout(function () {

    //   cartFlyoutUpdater();


    // }, 750);

  });
  */



  $('.product-submit').on('click',function (e) {

    if($(this).hasClass('swatch-packet-atc')) {

      var swNm =  $(this).parents('form').find('.current-variation option:selected').text();

      localStorage.setItem('packet', swNm);
    }

    window.setTimeout(function () {
      cartFlyoutUpdater();
    }, 750);

  });

  window.setTimeout(function () {
    cartFlyoutUpdater();
  }, 1200);


};


_pc.rebuy = function() {

  document.addEventListener('rebuy.ready', function(event){

    document.addEventListener('rebuy.add', function(event){

      console.log('rebuy.add event', event.detail);

	  var prod = event.detail.product.id;
      var prodID = event.detail.product.selected_variant_id;
      var prodVar = event.detail.product.selected_variant.title;
      var prodTitle = event.detail.product.title;
      var prodLink = '/products/'+event.detail.product.handle+'?variant='+event.detail.product.selected_variant_id;
      var prodPrice = event.detail.product.selected_variant.price;
      var prodImg = event.detail.product.image.src;

      var prodPrce = prodPrice.replace('.00','');
      var cartPrice = $('.cart-mini-subtotal-value').text().replace('$','').replace('.00','').replace(',','');
      var newCartPrice = parseInt(cartPrice) + parseInt(prodPrce);




      console.log('prodID '+prodID);
      console.log('prodVar '+prodVar);
      console.log('prodTitle '+prodTitle);
      console.log('prodLink '+prodLink);
      console.log('prodPrice '+prodPrice.replace('.00',''));
      console.log('prodImg '+prodImg);

      var newImage = $('.rebuy-product-block.product-id-'+prod).find('.rebuy-product-image').find('img').attr('src');


      $('.cart-mini-item').each(function(index) {
        var linenum = $(this).find('.btn-quantity--less').attr('data-line');
        var linenum = parseInt(linenum);
        var newlinemum = linenum + 1;

        $(this).find('.btn-quantity--less').attr('data-line', newlinemum);
        $(this).find('.btn-quantity--more').attr('data-line', newlinemum);
      });

      $('.cart-mini-items').prepend([

        '<div class="cart-mini-item rebuyitem" data-cart-mini-item="'+prodID+'">',

        '<div class="cart-mini-item-column cart-mini-item-column-image">',
        '<figure class="cart-mini-item-image">',
        '<img src="'+newImage+'" alt="">',
        '</figure>',
        '</div>',

        '<div class="cart-mini-item-column cart-mini-item-column-details">',

        '<span class="cartmini-item-title">',
        '<a href="'+prodLink+'">'+prodTitle+'</a>',
        '<div class="cart-mini-item-column cart-mini-item-column-remove">',
        '<div class="cart-mini-item-remove" aria-label="remove" role="button" data-cart-mini-item-remove="'+prodID+'">',
        '<span>Remove</span>',
        '</div>',
        '</div>',
        '</span>',

        '<span class="cartmini-item-variant ss">'+prodVar+'</span>',

        '<span class="cart-mini-item-price money" actual-value="$'+prodPrice+'&quot;">',
        '<span class="cart-mini-item-quantity">',
        '<button class="btn-quantity btn-quantity--less" data-line="1">−</button>',
        '<input type="number" data-ajax-qty="" name="updates[]" id="updates_'+prodID+':xxx" value="1" min="0" data-id="'+prodID+':xxx" disabled="" step="1">',
        '<button class="btn-quantity btn-quantity--more" data-line="1">+</button>',
        '</span>',
        '<div class="pn-total-line-item" data-id="'+prodID+':xxx">$'+prodPrice+'</div>',
        '</span>',

        '</div>',

        '</div>'

      ].join("\n"));

      $('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');

      var cartCount =  parseInt($('.main-header--tools-group .mini-cart-wrap .item-count').text());
      var newCartCount = cartCount + 1;

      $('.main-header--tools-group .mini-cart-wrap .item-count').text(newCartCount);


      $('.rebuyitem [data-cart-mini-item-remove]').on('click', function (e) {

        var remPrice = $(this).parents('.rebuyitem').find('.pn-total-line-item').text().replace('$','').replace('.00','').replace(',','');
        var cPrice = $('.cart-mini-subtotal-value').text().replace('$','').replace('.00','').replace(',','');
        var nCartPrice = parseInt(cPrice) - parseInt(remPrice);

        $('.cart-mini-subtotal-value').text('$'+nCartPrice+'.00');


        var cCount =  parseInt($('.main-header--tools-group .mini-cart-wrap .item-count').text());
        var nCartCount = cCount - 1;

        $('.main-header--tools-group .mini-cart-wrap .item-count').text(nCartCount);

        $(this).parents('.rebuyitem').remove();





		var linenmbr = $(this).parents('.rebuyitem').find('.btn-quantity--more').attr('data-line');

        CartJS.removeItem(linenmbr);

        $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', nCartCount);



      });


      window.setTimeout(function () {
        // cartFlyoutUpdater();
      }, 1200);


    });

  });

};


function cartFlyoutUpdater() {


  isCartClick = true;

  var cartCount =  $('.main-header--tools-group .mini-cart-wrap .item-count').text();

  $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', cartCount);

  window.setTimeout(function () {

    $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', cartCount);

  }, 100);


  if(cartCount == '0') {
    $('.cart-mini-rec').addClass('hide-rec');
  }
  if(cartCount != '0') {
    $('.cart-mini-rec').removeClass('hide-rec');
  }

  var updateCart = async function (lineNo, newQuant) {
    var updatedCart = await _updateItem(lineNo, newQuant);
    var newLinePrice = Shopify.formatMoney(updatedCart.items[lineNo - 1].final_line_price, Shopify.moneyFormat);
    var newCartPrice = Shopify.formatMoney(updatedCart.total_price, Shopify.moneyFormat);
    var newCartCount = updatedCart.item_count;

    $(this).parents('.cart-mini-item').find('.cart-mini-item-quantity').find('input').val(newQuant);
    $(this).parents('.cart-mini-item').find('.pn-total-line-item').text(newLinePrice);
    $(this).parents('form').find('.cart-mini-subtotal-value').text(newCartPrice);

    $('.main-header--tools-group .mini-cart-wrap .item-count').text(newCartCount);
    $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', newCartCount);

    console.log('newLinePrice: ' +newLinePrice);
    console.log('newCartPrice: ' +newCartPrice);
    console.log('newCartCount: ' +newCartCount);
    return true;
  };

  var updateGift = async function (giftUUID, dir = 'increase') {
    if (!giftUUID) return;
    console.log('updateGift', dir)
    const cartReponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartReponse.json();
    const giftItem = cart ? (cart.items || []).find(item => item.properties && item.properties['Is Gift'] === 'Yes' && item.properties._giftUUID === giftUUID) : null;
    const giftKey = giftItem.key
    const giftQuantity = giftItem.quantity
    const updateQuantity = dir === 'increase' ? giftQuantity + 1 : (dir === '0' ? 0 : giftQuantity - 1)
    console.log('updateGift', giftKey, updateQuantity)
    const updateResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: giftKey, quantity: updateQuantity })
    })
    const updatedCart = await updateResponse.json()
    const updatedCartItem = updatedCart ? (updatedCart.items || []).find(item => item.key === giftKey) : null
    const $updatedGiftEl = $(`.js-cart-mini-item-gift[data-gift-uuid="${giftUUID}"]`);
    if (!updateQuantity) {
      $updatedGiftEl.length && $updatedGiftEl.remove()
    } else if (updatedCartItem && $updatedGiftEl.length) {
      const price = `<span>${Shopify.formatMoney(updatedCartItem.line_price, Shopify.moneyFormat)}</span>`
      const originPrice = updatedCartItem.original_line_price !== updatedCartItem.line_price
        ? `<s>${Shopify.formatMoney(updatedCartItem.original_line_price, Shopify.moneyFormat)}</s>`
        : ''
      $updatedGiftEl.find('.pn-total-line-item').html(`
        ${originPrice}
        ${price}
      `);
      $updatedGiftEl.find('.js-cart-item-input').val(updateQuantity)
    }
    $('.main-header--tools-group .mini-cart-wrap .item-count').text(updatedCart.item_count);
    $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', updatedCart.item_count);
    return true;
  };

  // $('.cart-mini .cart-mini-sidebar').delegate('.btn-quantity--less', 'click', async function (e) {
  //   e.preventDefault();
  //   e.stopImmediatePropagation();

  //   var cartCount =  $('.main-header--tools-group .mini-cart-wrap .item-count').text();

  //   var lineNo = $(this).attr('data-line');
  //   var currQuant = $(this).parents('.cart-mini-item').find('.cart-mini-item-quantity').find('input').val();
  //   var newQuant = parseInt(currQuant) - parseInt(1);

  //   console.log('Current Quantity: '+currQuant);
  //   console.log('New Quantity: '+newQuant);
  //   $('.js-mini-cart-item').attr('disabled', 'disabled');

  //   var thisPrice = $(this).parents('.cart-mini-item').find('.cart-mini-item-price').attr('actual-value').replace('$','').replace('.00','').replace(',','');
  //   var linePrice = $(this).parents('.cart-mini-item').find('.pn-total-line-item').text().replace('$','').replace('.00','').replace(',','');
  //   var cartPrice = $('.cart-mini-subtotal-value').text().replace('$','').replace('.00','').replace(',','');

  //   var newLinePrice = parseInt(linePrice) - parseInt(thisPrice);
  //   var newCartPrice = parseInt(cartPrice) - parseInt(thisPrice);

  //   var newCartPrice = newCartPrice.toString();
  //   var newCartPrice = newCartPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

  //   var newCartCount = parseInt(cartCount) - parseInt(1);

  //   const giftUUID = $(this).closest('[data-gift-uuid]').data('gift-uuid');
  //   const promises = [];

  //   if(newQuant == '0') {

  //     if($('.cart-mini-item[data-cart-mini-item]').length == 1) {
  //       // $('.cart-flyout-inner').html('<div class="text-center cart-empty"><h3>Your cart</h3><p class="cart--empty-message">Your cart is currently empty.</p><p class="cart--cookie-message">Enable cookies to use the shopping cart</p><p class="cart--continue-browsing">Continue browsing <a href="/pages/shop">here</a>.</p></div>');

  //       $('.cart-mini-footer').empty();
  //       $('.cart-mini-content').prepend('<div class="cart-mini-empty">You don’t have any items in your cart yet.</div>');
  //       $(this).parents('.cart-mini-item').remove();
  //       promises.push(_updateItem(lineNo, newQuant));

  //       // $('.cart-mini-rec').addClass('hide-rec');
  //     } else {
  //       $(this).parents('.cart-mini-item').remove();
  //       $('.cart-mini').find('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');

  //       $('.cart-mini-item').each(function(i) {
  //         var newNum = ++i;
  //         // $(this).attr('data-prodline', newNum);
  //         $(this).find('[data-line]').attr('data-line', newNum);
  //       });
  //       promises.push(_updateItem(lineNo, newQuant));

  //       // $('.cart-mini-rec').addClass('hide-rec');

  //     }

  //     console.log('is-zero');

  //     // $('.cart-mini-rec').addClass('hide-rec');

  //     console.log('newQuant: ' +newQuant);
  //     console.log('newLinePrice: ' +newLinePrice);
  //     console.log('newCartPrice: ' +newCartPrice);
  //     console.log('newCartCount: ' +newCartCount);
  //   } else {
  //     promises.push(updateCart.call(this, lineNo, newQuant));
  //   }

  //   $('.main-header--tools-group .mini-cart-wrap .item-count').text(newCartCount);
  //   $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', newCartCount);

  //   if(newCartCount == '0') {
  //     $('.cart-mini-rec').addClass('hide-rec');
  //   }

  //   if (giftUUID) {
  //     if(newQuant == '0') {
  //       promises.push(updateGift(giftUUID, '0'))
  //     } else {
  //       promises.push(updateGift(giftUUID, 'decrease'));
  //     }
  //   }
  //   await Promise.all(promises);
  //   return false;
  // });

  // $('.cart-mini .cart-mini-sidebar').delegate('.btn-quantity--more', 'click', async function (e) {
  //   e.preventDefault();
  //   e.stopImmediatePropagation();

  //   var cartCount =  $('.main-header--tools-group .mini-cart-wrap .item-count').text();

  //   var lineNo = $(this).attr('data-line');
  //   var currQuant = $(this).parents('.cart-mini-item').find('.cart-mini-item-quantity').find('input').val();
  //   var newQuant = parseInt(currQuant) + parseInt(1);
  //   $('.js-mini-cart-item').attr('disabled', 'disabled');
  //   console.log('updateCart', $('.js-mini-cart-item'))

  //   const promises = [
  //     updateCart.call(this, lineNo, newQuant)
  //   ]

  //   const giftUUID = $(this).closest('[data-gift-uuid]').data('gift-uuid');
  //   if (giftUUID) {
  //     promises.push(updateGift(giftUUID))
  //   }
  //   await Promise.all(promises);

  //   console.log('Current Quantity: '+currQuant);
  //   console.log('New Quantity: '+newQuant);
  //   return false;
  // });
  $('.cart-mini .cart-mini-sidebar').delegate('.js-go-to-checkout', 'click', async function (e) {
    let formData = {
      note: $('.js-cart-text').val()
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log($('.js-cart-text').val())
      window.location.href ='/checkout'
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  });
  const trasholdCalculator = () => {
    setTimeout(async function(){
        const cartRequest = await fetch('/cart');
        if (cartRequest.status !== 200) return;
        const cart = cartRequest.json();
        let cartCountNumber = cart.item_count;
        if(cartCountNumber == 0) {
            cartCalculator.classList.add('cartCalculator__hide')
        } else {
            cartCalculator.classList.remove('cartCalculator__hide')
        }
        let dataPicker
        let barFillNumber
        let price = cart.total_price / 100
        let obj = globalJson
        let valueArray = []
        Object.keys(obj).forEach(function(key) {
            valueArray.push(key)
        });
        for (var i = 0; i < valueArray.length; i++) {
            if (i == 0 && price < valueArray[i]) {
                dataPicker = valueArray[i]
                break
            }
            if(price > valueArray[i - 1] && price < valueArray[i]) {
                dataPicker = valueArray[i]
                break
            }
            if( i == valueArray.length -1 ) {
              dataPicker = 'fallback'
            }
        }
        console.log(dataPicker, "dataPicker")
        let trasholdRemain = dataPicker - price
        let percentNumber = jsonData[dataPicker].percent
        let type
        if(jsonData[dataPicker].type == 'percent') {
            type = "%"
        } else {
            type = "$"
        }

        if(percentNumber) {
            barFillNumber = ((price/ dataPicker ) * 100) + '%'
        } else {
            barFillNumber = '100%'
        }
        console.log(barFillNumber, 'barFill')
        if( trasholdRemain > 0) {
            trasholdMessage.textContent = `$${trasholdRemain} away from getting ${percentNumber}${type} off!`
        } else {
            trasholdMessage.textContent = `You unlocked all your discounts. You may also like!`
            barFillNumber = '100%'
        }
        //percentTrashlod.textContent = percentNumber + '%'
        //cartTrashold.textContent = '$' + trasholdRemain
        cartCalculator.classList.add('loading')
        barFIl.style.width = barFillNumber
        const starterProduct = jsonData[dataPicker].product
        const product = await getProduct(starterProduct);
        productTitle.textContent = product.title
        productPrice.textContent = '$' + product.price / 100 + '.00'
        productUrl.href = '/products/' + product.handle
        productImage.src = product.featured_image
        productId.setAttribute('data-value', product.variants[0].id)
        setTimeout(function(){cartCalculator.classList.remove('loading')},500)
    },1000)
  }
  $('.cart-mini .cart-mini-sidebar').delegate('.cart-mini-item-remove', 'click', async function (e) {
    e.stopImmediatePropagation();
    const lineNo = $(e.target).closest('.cart-mini-item').find('[data-line]').attr('data-line');
    await _updateItem(lineNo, 0);
    const giftUUID = $(this).closest('[data-gift-uuid]').data('gift-uuid');
    if (giftUUID) {
      await updateGift(giftUUID, '0');
    }
    $(this).parents('.cart-mini-item').remove();
    if($('.cart-mini-item[data-cart-mini-item]').length == 0) {
      $('.cart-mini-footer').empty();
      $('.cart-mini-content').prepend('<div class="cart-mini-empty">You don’t have any items in your cart yet.</div>');
    } else {
      $('.cart-mini-item').each(function(i) {
        var newNum = ++i;
        // $(this).attr('data-prodline', newNum);
        $(this).find('[data-line]').attr('data-line', newNum);
      });
    }

    // trasholdCalculator()
    // var origQuant = $(this).parents('.cart-mini-item').find('[data-ajax-qty]').val();



    // window.setTimeout(function () {

    //   // var cartCount =  parseInt($('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount'));
	  // var newCartCount = cartCount - origQuant;

    //   $('.main-header--tools-group .mini-cart-wrap .item-count').text(newCartCount);

    //   $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', newCartCount);

    //   if(newCartCount == '0') {
    //     $('.cart-mini-rec').addClass('hide-rec');
    //   }

    // }, 100);




  });



  if(localStorage.getItem('packet')) {

	$('.cart-mini .cart-mini-item:first-child').find('.cartmini-item-title span').text(localStorage.getItem('packet'));

    localStorage.removeItem("packet");
  }


}




  /*
function cartUpdater() {

  var cartCount = $('.menu-cart').first().find('.cart-count span').text();

  $('.cart-content .btn-quantity--less').on('click',function (e) {
    e.preventDefault();

    var cartCount = $('.menu-cart').first().find('.cart-count span').text();

    var lineNo = $(this).attr('data-line');
    var currQuant = $(this).parents('.cart-prod').find('[data-label="Quantity"]').find('input').val();
    var newQuant = parseInt(currQuant) - parseInt(1);

    var thisPrice = $(this).parents('.cart-prod').find('[data-label="Price"]').find('.cart-product--price').text().replace('$','').replace('.00','').replace(',','');
    var linePrice = $(this).parents('.cart-prod').find('[data-label="Total"]').find('.cart-product--price').text().replace('$','').replace('.00','').replace(',','');
    var cartPrice = $(this).parents('form.cart').find('.cart__subtotal').text().replace('$','').replace('.00','').replace(',','');

    var newLinePrice = parseInt(linePrice) - parseInt(thisPrice);
    var newCartPrice = parseInt(cartPrice) - parseInt(thisPrice);

    var newCartPrice = newCartPrice.toString();
    var newCartPrice = newCartPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    var newCartCount = parseInt(cartCount) - parseInt(1);

    if(newQuant == '0') {

      if($('.cart-prod[data-product-id]').length == 1) {
        $('.cart-content').html('<div class="text-center cart-empty"><h3>Your cart</h3><p class="cart--empty-message">Your cart is currently empty.</p><p class="cart--cookie-message">Enable cookies to use the shopping cart</p><p class="cart--continue-browsing">Continue browsing <a href="/pages/shop">here</a>.</p></div>');
        _updateItem(lineNo, newQuant);
      } else {
        _updateItem(lineNo, newQuant);
        $(this).parents('.cart-prod').remove();
        $('.cart-content').find('.cart__subtotal').text('$'+newCartPrice+'.00');

        $('.cart__row[data-prodline]').each(function(i) {
          var newNum = ++i;
          $(this).attr('data-prodline', newNum);
          $(this).find('[data-line]').attr('data-line', newNum);
        });

      }

    } else {

      _updateItem(lineNo, newQuant);
      $(this).parents('.cart-prod').find('[data-label="Quantity"]').find('input').val(newQuant);
      $(this).parents('.cart-prod').find('[data-label="Total"]').find('.cart-product--price').text('$'+newLinePrice+'.00');
      $(this).parents('form.cart').find('.cart__subtotal').text('$'+newCartPrice+'.00');

      _updateItem(lineNo, newQuant);
      $(this).parents('.cart-prod').find('[data-label="Quantity"]').find('input').val(newQuant);
      $(this).parents('.cart-prod').find('[data-label="Total"]').find('.cart-product--price').text('$'+newLinePrice+'.00');
      $(this).parents('form.cart').find('.cart__subtotal').text('$'+newCartPrice+'.00');

    }

    $('.menu-cart').each(function(index) {
      $(this).find('.cart-count span').text(newCartCount);
    });

  });

  $('.cart-content .btn-quantity--more').on('click',function (e) {
    e.preventDefault();

    var cartCount = $('.menu-cart').first().find('.cart-count span').text();

    var lineNo = $(this).attr('data-line');
    var currQuant = $(this).parents('.cart-prod').find('[data-label="Quantity"]').find('input').val();
    var newQuant = parseInt(currQuant) + parseInt(1);

    var thisPrice = $(this).parents('.cart-prod').find('[data-label="Price"]').find('.cart-product--price').text().replace('$','').replace('.00','').replace(',','');
    var linePrice = $(this).parents('.cart-prod').find('[data-label="Total"]').find('.cart-product--price').text().replace('$','').replace('.00','').replace(',','');
    var cartPrice = $(this).parents('form.cart').find('.cart__subtotal').text().replace('$','').replace('.00','').replace(',','');

    var newLinePrice = parseInt(linePrice) + parseInt(thisPrice);
    var newCartPrice = parseInt(cartPrice) + parseInt(thisPrice);

    var newCartPrice = newCartPrice.toString();
    var newCartPrice = newCartPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    var newCartCount = parseInt(cartCount) + parseInt(1);

    _updateItem(lineNo, newQuant);
    $(this).parents('.cart-prod').find('[data-label="Quantity"]').find('input').val(newQuant);

    $(this).parents('.cart-prod').find('[data-label="Total"]').find('.cart-product--price').text('$'+newLinePrice+'.00');
    $(this).parents('form.cart').find('.cart__subtotal').text('$'+newCartPrice+'.00');

    $('.menu-cart').each(function(index) {
      $(this).find('.cart-count span').text(newCartCount);
    });

  });

}
*/
var bLazy = new Blazy({
  offset: 600,
  loadInvisible: true,
  success: function(ele){
    $(ele).parent().addClass('child-loaded');
    $.fn.matchHeight._update();
  }
});

// INITIALIZE
$(function() {
  _pc.set();
  _pc.scrolls();
  _pc.toggleNav();
  _pc.slick();
  _pc.accordion();
  _pc.scrollMagic();
  _pc.dropLists();
  _pc.formStuff();
  _pc.cartClick();
  _pc.misc();
  _pc.rebuy();
  _pc.tracking();
  // _pc.cartPage();
});

});
